function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Grid } from '../Grid';
import { IsUnaryFilter } from '../filterCommon';
import { GridFilterCell } from '../cells/GridFilterCell';
import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
/**
 *
 * @hidden
 */

var FilterRow =
/** @class */
function (_super) {
  __extends(FilterRow, _super);

  function FilterRow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FilterRow.prototype.headerCellClassName = function (field) {
    if (this.$props.sort && this.$props.sort.filter(function (descriptor) {
      return descriptor.field === field;
    }).length > 0) {
      return 'k-sorted';
    }

    return '';
  };

  FilterRow.prototype.setFilter = function (value, operator, field, e) {
    var filters = [];

    if (value !== '' && value !== null || operator !== '' && IsUnaryFilter(operator)) {
      filters.push({
        field: field,
        operator: operator,
        value: value
      });
    }

    if (this.$props.filter && this.$props.filter.filters) {
      var oldFilters = this.$props.filter.filters || [];
      oldFilters.forEach(function (filter) {
        var descriptor = filter;

        if (descriptor && descriptor.field !== field) {
          filters.push(descriptor);
        }
      });
    }

    var filtersResult = filters.length > 0 ? {
      logic: 'and',
      filters: filters
    } : null;
    this.$emit('filterchange', filtersResult, e);
  }; // @ts-ignore


  FilterRow.prototype.render = function (h) {
    var _this = this;

    var that = this;
    var oldFilters = this.$props.filter && this.$props.filter.filters || [];

    var activeFilterValueFor = function activeFilterValueFor(field, defaultValue) {
      if (defaultValue === void 0) {
        defaultValue = null;
      }

      var found = oldFilters.filter(function (filter) {
        return filter.field === field;
      })[0];
      return found ? found.value : defaultValue;
    };

    var activeOperatorFor = function activeOperatorFor(field) {
      var found = oldFilters.filter(function (filter) {
        return filter.field === field;
      })[0];
      return found ? found.operator : null;
    };

    var filterCellProps;
    var serviceIndex = 0,
        index = -1;
    var filterCells = this.$props.columns.filter(function (c) {
      return c.children.length === 0;
    }).map(function (column) {
      var onChangeFn = function onChangeFn(e) {
        _this.setFilter(e.value, e.operator, column.field, e);
      };

      var filterType = column.filter === undefined ? 'text' : column.filter;
      var filterRender = h(GridFilterCell, {
        attrs: {
          grid: _this.$props.grid,
          field: column.field,
          value: activeFilterValueFor(column.field, filterType === 'text' ? '' : null),
          operator: activeOperatorFor(column.field),
          filterType: column.filter === undefined ? 'text' : column.filter,
          render: column.filterCell || _this.$props.cellRender
        },
        on: {
          "change": onChangeFn
        }
      });
      var key = column.declarationIndex >= 0 ? ++index : --serviceIndex;
      var filterCell = h("th", {
        key: key,
        style: column.left !== undefined && {
          position: 'sticky',
          left: column.left + 'px',
          right: column.right + 'px',
          zIndex: 1,
          background: '#f6f6f6',
          borderRightWidth: column.rightBorder ? '1px' : ''
        } || {},
        "class": _this.headerCellClassName(column.field)
      }, [filterRender]);
      return column.filterable && filterCell || h("th");
    });
    return h("tr", {
      "class": "k-filter-row"
    }, [filterCells]);
  };

  FilterRow = __decorate([Component({
    props: {
      grid: Grid,
      columns: Array,
      filter: Object,
      field: String,
      filterType: String,
      value: Object,
      operator: String,
      onChange: Function,
      cellRender: [String, Function, Object]
    }
  })], FilterRow);
  return FilterRow;
}(VueComponent);

export { FilterRow };